<template>
  <div class="brand-apply">
    <div class="step">
      <el-steps :active="0" class="step-container" align-center>
        <el-step title="申请"></el-step>
        <el-step title="审批"></el-step>
        <el-step title="完成"></el-step>
      </el-steps>
    </div>
    <div class="content">
      <el-form
        :model="brandForm"
        :rules="brandRules"
        label-width="260px"
        label-position="right"
        class="container-body"
        ref="brandForm"
      >
        <el-form-item label="品牌中文名称：" prop="brandName">
          <span>{{ brandForm.brandName }}</span>
          <!-- <el-autocomplete
            style="width: 40%"
            :popper-append-to-body="false"
            v-model="brandForm.brandName"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入品牌中文名称"
            @select="handleSelect"
          ></el-autocomplete>
          <span v-if="ifBrandName">系统里没有此品牌哦，请您直接添加品牌信息进行申请</span> -->
        </el-form-item>
        <el-form-item label="品牌英文名称：" prop="brandNameEN">
          <el-input
            :disabled="brandForm.brandId"
            placeholder="请输入品牌英文名称"
            v-model="brandForm.brandNameEN"
            style="width: 40%"
          ></el-input>
        </el-form-item>
        <el-form-item class="image-content" label="品牌图片：" prop="brandImage">
          <multi-image-upload
            :uploadUrl="fileUploadForBrand"
            :url="imageUrls"
            :hasDel="!brandForm.brandId"
            :imageSize="4"
            @handleimgInfo="handleBrandImage"
            :verify="true"
          />
          <span class="text">支持JPG、JPEG、PNG格式，建议宽度小于500px，单张大小不超过4M。</span>
        </el-form-item>
        <el-form-item label="申请材料：" prop="brandFile" style="width: 60%;">
          <file-upload
            :uploadUrl="fileUploadForBrandFile"
            :url="fileList"
            accept=".pdf,.jpg,.jpeg,.png"
            :limit="1"
            :ifUploadBtn="!brandForm.brandId"
            @getFileInfo="getFileInfo"
            :uploadImage="true"
            :fileSize="20"
            :verify="true"
            :uploadTips.sync="fileUploadTips"
          >
            <template #message>
              <p>上传品牌授权书或品牌证明材料</p>
              <p>支持PDF、JPG、JPEG、PNG格式，文件大小不超过10M。</p>
            </template>
          </file-upload>
        </el-form-item>
        <el-form-item
          class="agreement-label"
          label="选择您要绑定的产品目录："
          prop="mdmCategoryName"
        >
          <div class="container-purchase">
            <div style="display: flex;">
              <div class="left">
                <div class="search">
                  <div>可售产品目录：</div>
                  <div class="scrollbar">
                    <el-scrollbar
                      ref="scrollbarCategory2"
                      @wheel.native.prevent="handleWheelCategory2"
                      style="height: 100%;"
                    >
                      <el-tree
                        class="tree"
                        :props="defaultProps"
                        :data="treeData"
                        node-key="categoryId"
                        ref="tree"
                        @node-click="nodeClick"
                      >
                        <template slot-scope="{ node }">
                          <el-tooltip
                            v-if="node.label.length > 15"
                            class="item"
                            effect="dark"
                            :content="node.label"
                            placement="right"
                          >
                            <div style="width:205px" class="ellipsis">{{ node.label }}</div>
                          </el-tooltip>
                          <span v-else>{{ node.label }}</span>
                        </template>
                      </el-tree>
                    </el-scrollbar>
                  </div>
                </div>
              </div>
              <div class="middle">
                <img
                  style="cursor: pointer"
                  src="../../../../../assets/img/agreement/right-arrow.png"
                />
              </div>
              <div class="right">
                <div>选中产品目录：</div>
                <div class="scrollbar">
                  <el-scrollbar
                    ref="scrollbarCategory3"
                    @wheel.native.prevent="handleWheelCategory3"
                    style="height: 100%;"
                  >
                    <ul>
                      <li
                        class="scrollbar-li"
                        :class="activeMdmInx == index ? 'scrollbar-active' : ''"
                        v-for="(item, index) in categoryList"
                        :key="index"
                        @click="handleMdmActive(index)"
                        @mouseover="handleMdmActive(index)"
                      >
                        <div style="display: flex;justify-content: space-between;">
                          <el-tooltip
                            v-if="item.categoryName.length > 15"
                            :content="item.categoryName"
                            placement="top"
                            effect="light"
                          >
                            <div style="width: 230px;margin-right: 20px" class="ellipsis">
                              {{ item.categoryName }}
                            </div>
                          </el-tooltip>
                          <div v-else style="width: 230px;margin-right: 20px" class="ellipsis">
                            {{ item.categoryName }}
                          </div>
                          <div>
                            <img
                              v-if="item.itemDel"
                              @click="handleDeleteData(item, index)"
                              style="width: 12px;height: 12px"
                              src="../../../../../assets/img/agreement/close.png"
                            />
                          </div>
                        </div>
                      </li>
                    </ul>
                  </el-scrollbar>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="备注：" prop="remark">
          <el-input
            :disabled="ifRemark"
            style="width: 70%;"
            maxlength="100"
            show-word-limit
            type="textarea"
            v-model="brandForm.remark"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>

    <div class="submit-btn">
      <el-button @click="handleGoBack">取消</el-button>
      <!-- 
        重复名称的编辑不了
       -->
      <div>
        <el-button type="primary" :loading="saveLoading" @click="handleSave">保存</el-button>
        <el-button type="primary" :loading="submitLoading" @click="handleSubmit">提交</el-button>
      </div>
    </div>
    <div class="hint">
      如果您在申请品牌的过程中遇到问题，请拔打电话010-85539100或发送邮件至wzwangyali@sinopec.com
    </div>
  </div>
</template>

<script>
import api from '../../../api/product';
import fileUpload from '../components/fileUpload.vue';
import multiImageUpload from '../components/multiImageUpload.vue';
const en = /^[A-Za-z0-9]+$/;
const validataBrandNameEN = (rule, value, callback) => {
  console.log(value);
  if (value) {
    if (!en.test(value)) {
      callback(new Error('请输入英文字母'));
    } else {
      callback();
    }
  } else {
    callback();
  }
};
export default {
  components: { fileUpload, multiImageUpload },
  props: {},
  data() {
    return {
      // 图片
      hasDel: true,
      ifUploadBtn: true,
      ifRemark: false,
      // 品牌图片上传地址
      fileUploadForBrand: api.fileUploadForBrand,
      // 资质上传
      fileUploadForBrandFile: api.fileUploadForBrandFile,
      // 选中产品目录
      categoryList: [],
      fileUploadTips: false,
      activeMdmInx: '',
      searchTreeShow: false,
      mdmCategoryQuery: {
        mdmCategoryName: '',
      },
      brandForm: {
        remark: '',
        // 申请材料
        brandFile: '',
        // 品牌图片
        brandImage: '',
        brandName: '',
        brandNameEN: '',
        // 已选产品目录
        categoryList: [],
        // 已选目录–数据库
        // categoryListInfo: {}
      },
      treeData: [],
      mdmDataList: [],
      defaultProps: {
        label: 'categoryName',
        children: 'children',
      },
      // pdf回显列表
      fileList: [],
      uploadUrl: api.fileUploadForProductFile,
      brandRules: {
        brandName: [{ required: true, message: '请输入品牌中文名称', trigger: 'blur' }],
        brandImage: [{ required: true,message: '请上传品牌图片'}],
        brandNameEN: [{ required: false, validator: validataBrandNameEN, trigger: 'blur' }],
      },
      // 图片
      imageUrls: [],
      brandNameSearchResult: [],
      ifBrandName: false,
      saveLoading: false,
      submitLoading: false,
    };
  },
  created() {
    this.getDetailInfo();
    this.getTreeData();
  },
  computed: {},
  methods: {
    async getDetailInfo() {
      const { brandAuditId } = this.$route.query;
      const { queryBrandAuditDetail } = api;
      const result = await queryBrandAuditDetail({ brandAuditId });
      if (result.code === '200') {
        const data = result.data;
        this.brandForm = Object.assign({}, data);
        this.imageUrls = this.brandForm.brandImage ? [this.brandForm.brandImage] : [];
        const brandFileArr = this.brandForm.brandFile ? this.brandForm.brandFile.split('.') : '';
        this.categoryList = this.brandForm.categoryList.length ? this.brandForm.categoryList : [];
        this.fileList = this.brandForm.brandFile
          ? [
              {
                fileUrl: this.brandForm.brandFile,
                fileName: `申请材料.${brandFileArr[brandFileArr.length - 1]}`,
              },
            ]
          : [];
      }
    },
    // 图片文件
    handleBrandImage(file) {
      this.brandForm.brandImage = file[0];
      console.log(this.brandForm.brandImage, '上传图片');
    },
    // 获取treeData
    async getTreeData() {
      const { getCategoryListByAgreement } = api;
      const res = await getCategoryListByAgreement();
      if (res.code === '200') {
        this.treeData = [...res.data];
      }
    },
    // 点击末级节点
    nodeClick(nodeData, node) {
      // 末级节点的 children.length === 0
      if (node.isLeaf) {
        this.$set(nodeData, 'itemDel', true);
        this.categoryList.push(nodeData);
        const obj = {};
        this.categoryList = this.categoryList.reduce(function(item, next) {
          obj[next.categoryId] ? '' : (obj[next.categoryId] = true && item.push(next));
          return item;
        }, []);
      }
    },
    // 获取上传文件
    getFileInfo(file) {
      console.log(file, '司法所发生');
      this.brandForm.brandFile =
        file.length !== 0 ? (this.brandForm.brandFile = file[0].fileUrl) : '';
    },
    // 删除选中目录
    handleDeleteData(item, index) {
      this.categoryList.splice(index, 1);
    },

    handleWheelCategory2(e) {
      let wrap = this.$refs.scrollbarCategory2.$refs.wrap;
      wrap.scrollTop = wrap.scrollTop - e.wheelDeltaY;
    },
    handleWheelCategory3(e) {
      let wrap = this.$refs.scrollbarCategory3.$refs.wrap;
      wrap.scrollTop = wrap.scrollTop - e.wheelDeltaY;
    },
    handleMdmActive(inx) {
      this.activeMdmInx = inx;
    },
    // 保存
    handleSave() {
      if (!this.brandForm.brandFile) {
        this.fileUploadTips = true;
        return false;
      }
      if (this.categoryList.length === 0) {
        this.$message({
          message: '请选择产品目录',
          type: 'warning',
        });
        return false;
      }

      this.$refs.brandForm.validate(async valid => {
        if (valid) {
          this.submit(0);
        }
      });
    },
    // 提交
    handleSubmit() {
      if (!this.brandForm.brandFile) {
        this.fileUploadTips = true;
        return false;
      }

      if (this.categoryList.length === 0) {
        this.$message({
          message: '请选择产品目录',
          type: 'warning',
        });
        return false;
      }

      this.$refs.brandForm.validate(async valid => {
        if (valid) {
          this.submit(1);
        }
      });
    },
    // 保存brandAuditStatus: 0/编辑1-提交审核 接口
    async submit(brandAuditStatus) {
      console.log(this.brandForm);
      this.brandForm.brandAuditStatus = brandAuditStatus;
      this.brandForm.categoryList = [...this.categoryList];
      // const { modifyBrandAuditContent } = api;
      // const res = await modifyBrandAuditContent(this.brandForm);
      const { addBrandAudit, saveBrand } = api;
      let res = null;
      if (brandAuditStatus === 0) {
        this.saveLoading = true;
        res = await saveBrand(this.brandForm);
        this.saveLoading = false;
      } else {
        this.submitLoading = true;
        res = await addBrandAudit(this.brandForm);
        this.submitLoading = false;
      }
      if (res.code === '200') {
        if (brandAuditStatus === 0) {
          this.$message({
            message: '您好，您的品牌申请已保存成功',
            type: 'success',
          });
        }
        if (brandAuditStatus === 1) {
          this.$message({
            message: '您好，您的品牌申请已提交成功，请等待平台运营人员审核通过后方可使用',
            type: 'success',
          });
        }
        this.$router.push({ path: '/brandManage' });
      }
    },
    handleGoBack() {
      this.$router.push({ path: '/brandManage' });
    },
  },
};
</script>

<style scoped lang="scss">
.brand-apply {
  .content {
    margin-top: 20px;
    background: #fff;
    padding-bottom: 0;
    .brand-name {
      position: relative;
      span {
        position: absolute;
        left: 0;
        top: 26px;
        font-size: 12px;
        color: #f0250f;
      }
    }
  }
  .container-body {
    width: 100%;
    margin-left: 20px;
    .el-input-width {
      width: 266px;
      height: 28px;
    }
    .container-purchase {
      background: #f8f8f8;
      width: 725px;
      height: 424px;
      padding: 20px;
      display: flex;
      flex-direction: column;
      .left {
        width: 308px;
        height: 360px;
        background-color: #ffffff;
        padding: 10px 10px 10px;
        .search {
          width: 100%;
          .scrollbar {
            height: 242px;
            overflow: hidden;
          }
        }
      }
      .right {
        width: 298px;
        height: 360px;
        background-color: #ffffff;
        padding: 10px 10px 10px;
        .scrollbar {
          height: 316px;
          overflow: hidden;
          .scrollbar-li {
            display: flex;
            justify-content: space-between;
            cursor: pointer;
          }
          .scrollbar-active {
            background: #f4f7ff;
          }
        }
      }
      .middle {
        width: 60px;
        height: 360px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          height: 35px;
          width: 18px;
        }
      }
      .tip {
        font-size: 14px;
        color: #999999;
      }
    }
    .agreement-label {
      .el-form-item__label:before {
        content: '* ';
        color: red;
      }
    }
    .image-content {
      position: relative;
      .text {
        /* position: absolute;
        left: 150px;
        top: 0; */
        color: #999999;
        font-size: 12px;
      }
      ::v-deep .el-upload--picture-card,
      ::v-deep .el-upload-list__item {
        width: 100px;
        height: 100px;
        line-height: 126px;
        text-align: center;
        border: 1px solid #c0ccda;
        i {
          font-size: 60px;
        }
        .el-upload-list__item-actions {
          line-height: 100px;
          .el-icon-delete,
          .el-icon-zoom-in {
            font-size: 22px;
          }
        }
      }
    }
    ::v-deep .uploadFile .warn-message {
      color: #999999;
      font-size: 12px;
    }
  }
  .submit-btn {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 20px;
    ::v-deep .el-button {
      min-width: 80px;
      height: 30px;
      font-size: 14px;
      padding: 0 10px;
      /* line-height: 30px; */
      text-align: center;
      & + .el-button {
        margin-left: 20px;
      }
    }
  }
  .hint {
    margin-top: 20px;
    background: #e8efff;
    color: #333333;
    height: 36px;
    text-align: center;
    line-height: 36px;
    font-size: 12px;
  }
  .step-container ::v-deep .el-step__head.is-process .el-step__line {
    border: 1px solid #2587ff;
    // left: 65%;
    background-color: transparent;
    margin-right: 45px !important;
    margin-left: 45px;
    top: 13px;
    // width: 150px;
  }
  .step-container ::v-deep .el-step__head.is-process .el-step__icon {
    width: 30px;
    height: 30px;
    color: #ffffff;
    border: 1px solid #2587ff;
    background: #2587ff;
  }
  .step-container ::v-deep .el-step__head.is-wait .el-step__line {
    border: 1px dashed #c5c5c5;
    // left: 65%;
    background-color: transparent;

    margin-right: 45px !important;
    margin-left: 45px;
    top: 13px;
    // width: 150px;
  }
  .step-container ::v-deep .el-step__head.is-wait .el-step__icon {
    width: 30px;
    height: 30px;
    color: #c5c5c5;
    border: 1px solid #c5c5c5;
  }
  .step-container ::v-deep .el-step__icon {
    width: 30px;
    height: 30px;
    border: 1px solid #d9d9d9;
    // background-color: transparent;
    background-color: #ededed;
  }
  .step-container.el-step__icon.is-text {
    border: 1px solid #d9d9d9;
  }
  .step-container.el-step__icon-inner {
    color: #c5c5c5;
    font-size: 14px;
    font-weight: 400;
  }
  .scrollbar ::v-deep .el-scrollbar__wrap {
    overflow: hidden;
    margin-right: 0 !important;
  }
  .scrollbar ::v-deep .el-scrollbar__bar.is-vertical {
    background: #f5f5f5;
    border-radius: 2px;
    width: 3px;
    opacity: 1;
    margin-right: -2px;
  }
  .scrollbar ::v-deep .el-scrollbar__bar.is-horizontal {
    background: #f5f5f5;
    border-radius: 2px;
    height: 3px;
    margin-bottom: -2px;
    &:hover {
      opacity: 0;
    }
  }
}
</style>
